import { Moment } from 'moment';
import { Moment as TimeZoneMoment } from 'moment-timezone';
import { MuniV3Schema } from '../services/deal.service.types';
import { DealType, Rating } from './deal.types';

export interface DesignationDealInfo {
  id: number;
  globalIssueId: string;
  syndicate: UnderwriterInfo[];
  priorityPolicy: PriorityPolicy;
}

export interface BasicDesignationIssue {
  id: number;
  globalIssueId: string;
  dealType: MuniV3Schema.DealType | DealType;
  size: number;
  description: string;
  date: string;
  seniorManagerDepartment: SeniorManagerDepartment;
  series: DesignationSeries[];
  dealStatus: string;
  designationStatus: string;
  totalAmountToDesignate: number;
  remainingAmountToDesignate: number;
  amountDesignated: number;
  desiLastModifiedUtcDateTime: string;
  dayToDayInd: boolean;
  toBeDeterminedInd: boolean;
  weekOfInd: boolean;
  expectedPricingDate: Moment;
  saleDateTime: Moment | TimeZoneMoment;
}

export interface SeniorManagerDepartment {
  id: number;
  name: string;
  orionId: number;
  shortName?: string;
}

export interface DesignationSeries extends BasicDesignationSeries {
  isAMT: boolean;
  isTaxable: boolean;
}

export interface DesignationIssue extends BasicDesignationIssue {
  isDayToDay: boolean;
  isTBD: boolean;
  isWeekOf: boolean;
  seniorManager: SeniorManagerDepartment;
  saleDate: Moment | TimeZoneMoment;
  series: DesignationSeries[];
}

export interface BasicDesignationSeries {
  id: number;
  size: number;
  state: string;
  altMinTaxInd: boolean;
  taxableInd: boolean;
  altMinTaxStateInd: boolean;
  taxableStateInd: boolean;
  ratings: DesignationRating[];
  ratingsUnderlying: DesignationRating[];
  underlyingRatings?: Rating[];
  corpCusip: boolean;
  insurer: string;
}
export interface DesignationRating {
  agency: string;
  rating: string;
  status: string;
  shortTerm?: string;
}
export interface UnderwriterInfo {
  id: number;
  departmentName: string;
  role: UnderWriterRole;
  shortName: string;
  bracketTypeCode: string;
}

export interface PriorityPolicy {
  priorityParagraphText: string;
  hasFreeText: boolean;
}

export enum UnderWriterRole {
  SM = 'SM',
  CS = 'CS',
  CM = 'CM',
  MEM = 'MEM',
  SG = 'SG',
  NM = 'NM',
  BM = 'BM',
  FA = 'FA',
  RF = 'RF'
}

export interface Underwriter {
  synUnderwriterId: number;
  amount: number;
}

export interface DesignationBreakdownPayload {
  allotmentIds: number[];
  unitTypeCode: string;
  underwriters: Underwriter[];
  buysideComments: string;
  maxLastModifiedUtcDateTime: string;
}

export interface Breakdown {
  unitTypeCode: string;
  underwriters: Underwriter[];
  buysideComments: string;
  lastModifiedByRoleTypeCode: string;
}

export interface DesignationBreakdown extends Breakdown {
  id: number;
  allotmentId: number;
  credit: number;
  amount: number;
  enteredByRoleTypeCode: string;
  lastModifiedUtcDateTime: string;
}

export interface DesignationEntryStatus {
  isBuysideFirmSetUpInCasa: boolean;
  allowBuysideDesiEntry: boolean;
  areAllotmentsReleased: boolean;
  areDesignationsFinal: boolean;
  isDealerBuysideConnected: boolean;
}

export enum DesignationsCardTypes {
  DesignationsActive = 'DesiActive',
  DesignationsFinal = 'DesiFinal'
}

export enum DesignationDealStatus {
  NotSubmitted = 'Not Submitted',
  Submitted = 'Submitted',
  Partial = 'Partial'
}

export enum UnitTypeCode {
  Percent = '%',
  Bonds = '#'
}
